import baseServices from '../../../services/base.services'

const getAll = async () => {
    try {
        var response = await baseServices.getDataTostacionDMH2({ opcion: 2, orden: 0, ultimo: 1, frecuencia: 1, periodo: 0 })
        if (response.data && response.data.length > 0) return response.data
        else return null
    } catch (e) {
        console.log(e)
        getAll()
    }
}

const exportedObject = {
    getAll
}

export default exportedObject